export default __webpack_public_path__ + "static/migis-25a210db473638ab287bf83121f78b00.svg";